import { XStack, YStack } from '@/components/ui/layout/layout';

import type { McpUsageSummary } from '../mcp-info.types';

function sumCounts(counts: Record<string, number>): number {
  return Object.values(counts).reduce((total, count) => total + count, 0);
}

function topEntry(counts: Record<string, number>): string {
  const top = Object.entries(counts).sort(([, a], [, b]) => b - a)[0];
  return top ? `${top[0]} (${top[1]})` : '-';
}

function SummaryTile({
  label,
  value,
  secondary,
}: {
  label: string;
  value: string;
  secondary?: string;
}) {
  return (
    <YStack className="flex-1 min-w-[140px] rounded-lg border border-border bg-surface px-3 py-2 gap-0.5">
      <span className="text-xs text-foreground-muted font-medium uppercase tracking-wide">
        {label}
      </span>
      <span className="text-xl font-mono font-semibold tabular-nums text-foreground truncate">
        {value}
      </span>
      {secondary && (
        <span className="text-xs text-foreground-subtle truncate">
          {secondary}
        </span>
      )}
    </YStack>
  );
}

export function McpInfoSummaryTiles({
  summary,
}: {
  summary: McpUsageSummary | undefined;
}) {
  const byClient = summary?.by_client_name ?? {};
  const byTool = summary?.by_tool_name ?? {};

  return (
    <XStack className="px-3 py-2 gap-2 border-b border-border shrink-0">
      <SummaryTile label="Calls" value={String(sumCounts(byClient))} />
      <SummaryTile
        label="Clients"
        value={String(Object.keys(byClient).length)}
        secondary={topEntry(byClient)}
      />
      <SummaryTile
        label="Tools"
        value={String(Object.keys(byTool).length)}
        secondary={topEntry(byTool)}
      />
    </XStack>
  );
}
